/**
 * Enterprise & bulk "Contact us" dialog — wraps UpgradeRequestForm so every
 * surface (pricing page, account billing, paywall) opens the same contact flow.
 */

import { Building2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { UpgradeRequestForm } from './UpgradeRequestForm';

export function EnterpriseContactDialog({
  open,
  onOpenChange,
  source,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  source: string;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-2 bg-primary">
            <Building2 className="w-6 h-6 text-white" />
          </div>
          <DialogTitle>Enterprise &amp; bulk</DialogTitle>
          <DialogDescription>
            Tell us about your team and volume — we'll get back to you with pricing and setup.
          </DialogDescription>
        </DialogHeader>
        <UpgradeRequestForm source={source} onSuccess={() => setTimeout(() => onOpenChange(false), 1800)} />
      </DialogContent>
    </Dialog>
  );
}
